import { render, staticRenderFns } from "./KasBesar.vue?vue&type=template&id=6ee375c5&"
import script from "./KasBesar.vue?vue&type=script&lang=js&"
export * from "./KasBesar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports